import {BaseContainerModel} from '../base-container.model';
import { bl_inv_pdg_element_import_file_helper_RowClass} from '../../dbschema/bl_inv_pdg_element_import_file_helper.model';

export class InventoryPdgElementImportFileHelper extends BaseContainerModel {
    bl_inv_pdg_element_import_file_helper: bl_inv_pdg_element_import_file_helper_RowClass = new bl_inv_pdg_element_import_file_helper_RowClass();
}
